import { filterDividers, urls } from '../../constants';
import { History } from './History';
import i18next from "../../i18n";
import { addSigner } from "../documents/counterpartyAccreditationCard";
import { hideModalDialog } from '../ModalDialog';
const mime = require('mime-types');
export function getArrayIds(columns) {
    let result = [];
    if (columns) {
        for (var i = 0; i < columns.length; i++)
            result.push(columns[i].id);
    }
    return result;
}
export function getFilterString(filterValues) {
    let filter = '';
    let addedCount = 0;
    let keys = filterValues ? Object.keys(filterValues) : [];
    for (var i = 0; i < keys.length; i++) {
        let values = filterValues[keys[i]];
        if (values.length > 0) {
            let needAdd = false;
            let addedPart = '';
            if (addedCount > 0)
                addedPart += filterDividers.FilterPartsDivider;
            addedPart += keys[i] + filterDividers.FilterNameValueDivider;
            for (var j = 0; j < values.length; j++) {
                if (values[j]) {
                    if (j > 0)
                        addedPart += filterDividers.FilterValuesDivider;
                    addedPart += encodeURIComponent(values[j]);
                    needAdd = true;
                }
            }
            if (needAdd) {
                addedCount++;
                filter += addedPart;
            }
        }
    }
    return filter;
}
export function parseFilterString(filter) {
    let filterValues = {};
    if (!filter)
        return filterValues;
    filter = decodeURIComponent(filter);
    let parts = filter.split(filterDividers.FilterPartsDivider);
    for (var i = 0; i < parts.length; i++) {
        let parts2 = parts[i].split(filterDividers.FilterNameValueDivider);
        if (parts2.length > 1 && parts2[0] && parts2[1]) {
            let key = parts2[0];
            let value = parts2[1];
            var valueParts = value.split(filterDividers.FilterValuesDivider);
            filterValues[key] = valueParts;
        }
    }
    return filterValues;
}
export async function getBase64(file, witMimType = false) {
    let result_base64 = await new Promise((resolve) => {
        let fileReader = new FileReader();
        fileReader.onload = (e) => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
    });
    if (file.size === 0) {
        return { mimeType: file.type, content: witMimType === true ? `data:${mime.lookup(file.name)};base64,0` : "0" };
    }
    if (!witMimType) {
        let index = result_base64.lastIndexOf(",");
        if (index !== -1) {
            result_base64 = result_base64.slice(index + 1)
        }
    }
    return { mimeType: file.type, content: witMimType ? result_base64 : result_base64.split(";").pop() };
}
export function readAsUint8Array(file) {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    return new Promise((resolve, reject) => {
        reader.onloadend = ({ target: { result } }) => resolve(new Uint8Array(result));
        reader.onerror = reject;
    });
}
export function sortArray(items, fildName, isAsk = true) {
    items.sort(function (a, b) {
        var index1 = a[fildName];
        var index2 = b[fildName];
        if (index1 === null || index1 === undefined)
            index1 = 0;
        if (index2 === null || index2 === undefined)
            index2 = 0;
        let result = 0;
        if (index1 < index2) result = -1;
        if (index1 > index2) result = 1;
        if (!isAsk)
            result *= -1;
        return result;
    });
}
export function ExportToCSV(columns, items, fileName = "") {
    var csvContent = i18next.t("number");
    if (columns && columns.length > 0) {
        for (let column of columns) {
            if (!(column.hidden === true))
                csvContent += ';"' + column.headerName.replaceAll('"', '""') + '"';
        }
    }
    csvContent += "\r\n";
    let index = 1;
    if (items && items.length > 0) {
        for (var item of items) {
            csvContent += index;
            for (let column of columns) {
                try {
                    if (!(column.hidden === true)) {
                        csvContent += ';"' + item.columns[column.name].replaceAll('"', '""') + '"';;
                    }
                }
                catch { csvContent += ";"; }
            }
            csvContent += "\r\n";
            index++;
        }
    }
    if (!fileName)
        fileName = "report.csv";
    if (!fileName.endsWith(".csv"))
        fileName += ".csv";
    let encodedUri = encodeURI(csvContent).replaceAll('#', '%23');
    if (window.navigator.msSaveBlob) { // IE
        csvContent = '\ufeff' + csvContent;
        let blob = new Blob([csvContent], { type: "data:text/csv;charset=utf-8,\uFEFF" });
        window.navigator.msSaveOrOpenBlob(blob, "report.csv");
    }
    else if (window.saveAs) {
        let blob = new Blob([csvContent], { type: "data:text/csv;charset=utf-8,\uFEFF" });
        window.saveAs(blob, "report.csv");
    }
    else {
        let link = document.createElement("a");
        link.setAttribute("href", "data:text/csv;charset=utf-8,\uFEFF" + encodedUri);
        link.setAttribute("download", fileName);
        link.dispatchEvent(new MouseEvent('click'));
    }
}
export const transliterationOfFirstLettersTable = {
    'Є': 'Ye', 'є': 'ye', 'Ї': 'Yi', 'ї': 'yi', 'Й': 'Y', 'й': 'y', 'Ю': 'Yu', 'ю': 'yu', 'Я': 'Ya', 'я': 'ya'
}
export const transliterationTable = {
    'А': 'A', 'а': 'a', 'Б': 'B', 'б': 'b', 'В': 'V', 'в': 'v', 'Г': 'H', 'г': 'h', 'Ґ': 'G', 'ґ': 'g', 'Д': 'D', 'д': 'd', 'Е': 'E', 'е': 'e', 'Є': 'Ie', 'є': 'ie', 'Ж': 'Zh', 'ж': 'zh',
    'З': 'Z', 'з': 'z', 'И': 'Y', 'и': 'y', 'І': 'I', 'і': 'i', 'Ї': 'I', 'ї': 'i', 'Й': 'I', 'й': 'i', 'К': 'K', 'к': 'k', 'Л': 'L', 'л': 'l', 'М': 'M', 'м': 'm', 'Н': 'N', 'н': 'n', 'О': 'O', 'о': 'o',
    'П': 'P', 'п': 'p', 'Р': 'R', 'р': 'r', 'С': 'S', 'с': 's', 'Т': 'T', 'т': 't', 'У': 'U', 'у': 'u', 'Ф': 'F', 'ф': 'f', 'Х': 'Kh', 'х': 'kh', 'Ц': 'Ts', 'ц': 'ts', 'Ч': 'Ch', 'ч': 'ch', 'Ш': 'Sh', 'ш': 'sh',
    'Щ': 'Shch', 'щ': 'shch', 'Ю': 'Iu', 'ю': 'iu', 'Я': 'Ia', 'я': 'ia', 'Ь': '', 'ь': ''
}
export function transliterateString(str, ownName = true) {
    if (!str)
        return str;
    var re = /^.{0,}[а-яa-z].{0,}$/;
    var isUpper = !re.test(str);
    re = /([A-Za-zА-Яа-я]{1,})['`]{1,}([A-Za-zА-Яа-я]{1,})/g;
    str = str.replace(re, '$1$2');
    if (!ownName) {
        str = str.replaceAll('зг', 'zgh');
        str = str.replaceAll('Зг', 'Zgh');
        str = str.replaceAll('зГ', 'zGH');
        str = str.replaceAll('ЗГ', 'ZGH');
    }
    for (let key in transliterationOfFirstLettersTable) {
        re = new RegExp(`(\b)${key}`, 'g');
        str = str.replace(re, '$1' + transliterationOfFirstLettersTable[key]);
    }
    for (let key in transliterationTable) {
        str = str.replaceAll(key, transliterationTable[key]);
    }
    if (isUpper)
        str = str.toUpperCase();
    return str;
}
export function urltoFile(url, filename, mimeType) {
    return (fetch(url)
        .then(function (res) { return res.arrayBuffer(); })
        .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
    );
}
export function getCurrentCompanyInfo() {
    return fetch('/home/getCurrentCompanyInfo')
        .then((response) => {
            return response.json();
        });
}
export function setUrlParam(key, value) {
    key = encodeURIComponent(key);
    value = encodeURIComponent(value);
    // kvp looks like ['key1=value1', 'key2=value2', ...]
    var kvp = document.location.search.substr(1).split('&');
    let i = 0;
    for (; i < kvp.length; i++) {
        if (kvp[i].startsWith(key + '=')) {
            let pair = kvp[i].split('=');
            pair[1] = value;
            kvp[i] = pair.join('=');
            break;
        }
    }
    if (i >= kvp.length) {
        kvp[kvp.length] = [key, value].join('=');
    }
    // can return this or...
    let params = kvp.join('&');
    if (params.length > 0) {
        if (params[0] === "&") {
            params = params.replace("&", "?");
        }
        else {
            params = "?" + params;
        }
    }
    History.push(document.location.pathname + params);
}
export function getUrlParam(param) {
    let result = null;
    let parts = window.location.search.substring(1).split('&');
    if (parts.length > 0) {
        for (var i in parts) {
            var parts2 = parts[i].split('=');
            if (parts2.length > 1 && parts2[0].toLocaleLowerCase() === param.toLocaleLowerCase()) {
                result = parts2[1].toLocaleLowerCase();
                break;
            }
        }
    }
    return result;
}
export function getCurrentUrlPath() {
    let curUrl = window.location.pathname;
    if (curUrl && curUrl.length > 1 && curUrl[curUrl.length - 1] === '/')
        curUrl = curUrl.substring(0, curUrl.length - 1);
    return curUrl;
}
export function getWordWithCorrectEnding(number, word) {
    // eslint-disable-next-line default-case
    switch (word) {
        case i18next.t("attemptCorrectWord1"):
            {
                let lastTwoNumbers = Math.round(((number / 100) % 1) * 100);
                if (number % 0 === 0 || number % 5 === 0 || number % 6 === 0 || number % 7 === 0 || number % 8 === 0 || number % 9 === 0 || (lastTwoNumbers >= 11 && lastTwoNumbers <= 19))
                    return i18next.t("attemptWordRest");
                if (number % 2 === 0 || number % 3 === 0 || number % 4 === 0)
                    return i18next.t("attemptWord2to4");
                if (number % 1)
                    return i18next.t("attemptCorrectWord1");
            }
            break;
    }
    return word;
}
export function base64toBlob(data, mimeType) {
    const prefix = `data:${mimeType};base64,`;
    if (data.startsWith(prefix)) {
        data = data.substr('data:application/pdf;base64,'.length);
    }
    const bytes = atob(data);
    let length = bytes.length;
    let out = new Uint8Array(length);
    while (length--) {
        out[length] = bytes.charCodeAt(length);
    }
    return new Blob([out], { type: mimeType });
};
export async function logout() {
    const response = await fetch('/Account/LogOut', { method: "POST" });
    if (response.ok || response.status === 401 || !localStorage.getItem('user')) {
        if (localStorage.getItem('user')) {
            localStorage.removeItem('user');
        }
        import('../ModalDialogsTemplates').then(templates => { templates.showLoader() });
        window.onbeforeunload = null;
        document.location.replace(urls.loginPageUrl);
    }
    else {
        require('../ModalDialogsTemplates').unknownErrorMessageDialog();
    }
};
export function changeInputValue(e) {
    const { name, type, value, checked } = e.target;
    if (name === "prop_sxcfc_hasAccountant") {
        if (checked) {
            this.setState({ [name]: false }, () => {
                addSigner.bind(this)(true);
            });
        }
        else {
            let confirmDialog = () => {
                this.deleteAccountant();
            }
            this.setState({ [name]: true }, () => {
                require('../ModalDialogsTemplates').yesNoMessageDialog(i18next.t("removing"), i18next.t("removeAccountantMainPageMessage"), confirmDialog);
            });
        }
    }
    else if (name === "elevatorData") {
        this.setState({
            prop_sxcfc_acceptedProducts: value.intake,
            prop_sxcfc_shippedProducts: value.outtake,
            prop_sxcfc_writtenOffProducts: value.shrink
        });
    }
    else {
        this.setState({ [name]: type === "checkbox" ? checked : value }, () => {
            if (name === "prop_sx_docKind") {
                onDocKindChanged.bind(this)();
            }
        });
    }
}
export async function onDocKindChanged() {
    if (this.state.type === "sxcfc:incomingDocument") {
        if (this.state.associations?.contractAssoc?.length > 0 || this.state.assoc_sxcfc_contractAssoc_added) {
            let contractId = this.state.assoc_sxcfc_contractAssoc_added.split('workspace://SpacesStore/')[1];
            let docSubKind = await getMappedDocSubKind.bind(this)(contractId);
            if (docSubKind) {
                this.setState({ prop_sx_docSubKind: docSubKind });
                return;
            }
        }
    }
}
export async function getMappedDocSubKind(contractId) {
    const { prop_sx_docSubKind, prop_sx_docKind } = this.state;
    let result = prop_sx_docSubKind;
    const response = await fetch(`/Document/GetMappedDocSubKind?contractId=${contractId}&docKind=${prop_sx_docKind}`);
    if (response.ok) {
        const mappedSubKind = await response.text();
        if (mappedSubKind)
            result = mappedSubKind;
    }
    else {
        console.log('GetMappedDocSubKind error');
    }
    return result;
}

export function deepObjectEqual(object1, object2) {
    if (!object1 && !object2)
        return true;
    if (!object1 || !object2)
        return false;

    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = isObject(val1) && isObject(val2);
        if (
            (areObjects && !deepObjectEqual(val1, val2)) ||
            (!areObjects && val1 !== val2)
        ) {
            return false;
        }
    }

    return true;
}

export function isObject(object) {
    return object != null && typeof object === 'object';
}

export function encodeHTMLEntities(text) {
    if (!text)
        return '';
    var p = document.createElement('p');
    p.textContent = text;
    return p.innerHTML;
}

export function decodeHTMLEntities(text) {
    if (!text)
        return '';
    var textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
}

export function onFormInputKeyDown(e) {
    if (e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
    }
}

export function formatFloatTextValue(value, accuracy = 3) {
    let result = value;
    if (value) {
        if (typeof value === 'number') {
            value = value.toFixed(accuracy);
        }

        value = value.replaceAll(' ', '').replaceAll('.', ',');
        if ((/^-?[0-9]{0,}[,]?[0-9]{0,}$/).test(value)) {
            if (!value.includes(',')) {
                value += ',';
                for (let i = 0; i < accuracy; i++) {
                    value += '0';
                }
            }
            let parts = value.split(',');
            while (parts[1].length < accuracy) {
                parts[1] += '0';
            }
            value = `${parts[0]},${parts[1]}`;
            result = value.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }
    }
    return result;
}
export function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}